import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../dialogs/error-dialog/error-dialog.component';

export type ErrorDialogType = 'error' | 'warning' | 'info' | 'permission';

@Injectable({
    providedIn: 'root',
})
export class ErrorDialogService {
    constructor(private dialog: MatDialog) {}

    /**
     * Exibe um dialog de erro
     * @param message Mensagem a ser exibida
     * @param type Tipo do dialog (error, warning, info, permission)
     */
    show(message: string, type: ErrorDialogType = 'error'): void {
        const title = this.getTitleByType(type);
        const visualType = type === 'warning' ? 'warning' : 'error';

        this.dialog.open(ErrorDialogComponent, {
            data: {
                title,
                message,
                type: visualType,
            },
            width: '500px',
            panelClass: 'error-dialog',
        });
    }

    /**
     * Exibe um dialog de erro de permissão
     * @param message Mensagem a ser exibida
     */
    showPermissionError(message: string): void {
        this.show(message, 'permission');
    }

    /**
     * Retorna o título baseado no tipo
     */
    private getTitleByType(type: ErrorDialogType): string {
        const titles: Record<ErrorDialogType, string> = {
            error: 'Erro',
            warning: 'Atenção',
            info: 'Informação',
            permission: 'Acesso Negado',
        };

        return titles[type] || titles.error;
    }
}

